module.exports = __webpack_public_path__ + "img/empty-folder.36a44db3.png";